<template>
  <ThemeDefaultLayoutPage
    :title="asyncCategory?.section.title"
    :description="asyncCategory?.section.description"
    :breadcrumbs="breadcrumbs"
    :categories="asyncCategory?.categoryButtonItems"
    :event-name="eventName"
    :category-event-name="categoryEventName"
    custom-padding="lg:!tw-py-11 !tw-py-6"
  >
    <div v-if="videos.length > 0">
      <div class="tw-grid md:tw-grid-cols-2 tw-grid-cols-1 tw-gap-x-5 tw-gap-y-8">
        <div
          v-for="item in videos"
          :key="item._id"
        >
          <ThemeDefaultCardVideo
            title-tag="h2"
            :youtube-url="item.youtubeUrl || ''"
            :title="item.title || ''"
            :description="item.description"
            :video-category="item.videoCategory"
            custom-video-title-class="tw-text-mb-title-4 lg:!tw-text-dt-title-4"
            @click="eventVideo(item.title)"
          />
        </div>
      </div>
      <Pagination
        v-model="page"
        :total="total"
        :per-page="perPage"
      />
    </div>
    <LandingNoData
      v-else
    />
  </ThemeDefaultLayoutPage>
</template>

<script setup lang="ts">
const {
  categoryEventName,
  eventName,
  asyncCategory,
  breadcrumbs,
  videos,
  page,
  perPage,
  total,
  eventVideo,
} = await useVideoPage()
</script>
